import { useAbility } from 'utilities/ability'

// Mirrors the Live updates scene's own guard (MerchantSettings 'access'), so a
// viewer who would be redirected sees plain text instead of a link.
// Fails closed while the ability loads.
export function useCanOpenLiveUpdates(): boolean {
  const ability = useAbility()
  return ability.can('access', 'MerchantSettings')
}

export default useCanOpenLiveUpdates
